import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Logo from '../components/Logo';

const LoginPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');
  const [googleAuthEnabled, setGoogleAuthEnabled] = useState(false);

  useEffect(() => {
    // Check for OAuth errors in URL params
    const oauthError = searchParams.get('error');
    const oauthMessage = searchParams.get('message');
    if (oauthError) {
      setError(oauthMessage || 'Authentication failed');
    }

    // Check if Google OAuth is enabled
    checkGoogleAuth();
  }, [searchParams]);

  const checkGoogleAuth = async () => {
    try {
      const response = await fetch('/api/auth/google/check');
      const data = await response.json();
      setGoogleAuthEnabled(data.enabled);
    } catch (error) {
      console.error('Failed to check Google auth status:', error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <div className="flex justify-center mb-6">
            <Logo size="large" showCompanyName={true} />
          </div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Organizer Login
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Sign in with your @star.london Google account
          </p>
        </div>
        
        {error && (
          <div className="rounded-md bg-red-50 p-4 mt-6">
            <p className="text-sm text-red-800">{error}</p>
          </div>
        )}

        {googleAuthEnabled ? (
          <div className="mt-8">
            <a
              href="/api/auth/google/login"
              className="w-full flex justify-center items-center px-4 py-3 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              <svg className="w-5 h-5 mr-3" viewBox="0 0 24 24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              Sign in with Google
            </a>
            <p className="mt-4 text-center text-xs text-gray-600">
              Only @star.london email addresses are allowed
            </p>
          </div>
        ) : (
          <div className="mt-8">
            <div className="rounded-md bg-yellow-50 p-4">
              <p className="text-sm text-yellow-800">
                Google OAuth is not configured. Please contact your administrator.
              </p>
            </div>
          </div>
        )}

        <div className="text-center">
          <Link to="/" className="text-sm text-blue-600 hover:text-blue-500">
            Back to events
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;